const defaultState = {
  statistics: {},
  chartData: [],
};

const dashboard = (state = defaultState, { type, payload }) => {
  switch (type) {
    case 'DASHBOARD_STATISTICS_SUCCESS':
      return {
        ...state,
        statistics: payload && payload.data,
      };
    case 'DASHBOARD_CHART_DATA_SUCCESS': {
      const { data = {} } = (payload || {});
      /*
       * `data` looks like:
       * daily: [
       *   {
       *     date: '2018-01-01',
       *     models: [
       *       {
       *         name: 'model1',
       *         total: 3,
       *       },
       *       {
       *         name: 'model2',
       *         total: 3,
       *       },
       *     ],
       *   },
       *   {
       *     date: '2018-01-02',
       *     models: [
       *       {
       *         name: 'model1',
       *         total: 3,
       *       },
       *       {
       *         name: 'model2',
       *         total: 3,
       *       },
       *     ],
       *   },
       *   ...
       * ]
       *
       * this reducer transforms data that consumable by Recharts:
       * [
       *    {
       *      date: '2018-01-01',
       *      model1: 3,
       *      model2: 3,
       *    },
       *    {
       *      date: '2018-01-02',
       *      model1: 0,
       *      model2: 0,
       *    },
       *    {
       *      date: '2018-01-02',
       *      model1: 4,
       *      model2: 0,
       *    },
       *    {
       *      date: '2018-01-00',
       *      model1: 0,
       *      model2: 7,
       *    },
       * ],
       */
      const chartData = data.daily.map(item => ({
        ...item,
        ...item.models.reduce((acc, modelData) => {
          acc[modelData.name] = modelData.total;
          return acc;
        }, {}),
      }));

      return {
        ...state,
        chartData,
      };
    }
    default:
      return state;
  }
};

const reducers = {
  dashboard,
};
export default reducers;



// WEBPACK FOOTER //
// ./src/reducers.js